export function toMonsterAcNote(acNote: string) {
	return acNote.startsWith('+ ') ? acNote : `(${acNote})`;
}
